import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

export interface ConfirmDeleteGroupData {
  groupName: string;
  groupType: string;
}

@Component({
  selector: 'app-confirm-delete-group',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-delete-group.component.html',
  styleUrl: './confirm-delete-group.component.scss',
})
export class ConfirmDeleteGroupComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteGroupData,
    private dialogRef: MatDialogRef<ConfirmDeleteGroupComponent>
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
